module.exports = __webpack_public_path__ + "static/media/logo-yellow.be7bdcda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/kwoot/logo-yellow.svg
// module id = 183
// module chunks = 0